import { BrowseWordsPage } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.words";

export default function BrowseWordsRoute() {
  return <BrowseWordsPage />;
}
